function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:transparent;}\n\t.st1{fill:transparent;}\n\t.st2{fill:transparent;}\n\t.st3{fill:transparent;}\n\t.st0.active{fill:#F95C4F;}\n\t.st1.active{fill:#F76D6D;}\n\t.st2.active{fill:#F48E8E;}\n\t.st3.active{fill:#F48787;}\n\t.st4{fill:none;stroke:#555E60;stroke-width:4;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "u201"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,3893.2 882.2,3670.9 882.2,3832.8 1267.2,4055  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,3891.2 1646.2,3668.9 1646.2,3832.8 1265.3,4055  "
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "u301"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,3732.4 882.2,3510.2 882.2,3672 1267.2,3894.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,3730.4 1646.2,3508.2 1646.2,3672 1265.3,3894.2  "
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "u401"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,3581.7 882.2,3359.4 882.2,3511.3 1267.2,3733.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,3579.7 1646.2,3357.4 1646.2,3511.3 1265.3,3733.5  "
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "u501"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,3431.9 882.2,3209.7 882.2,3361.5 1267.2,3583.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,3429.9 1646.2,3207.7 1646.2,3361.5 1265.3,3583.8  "
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "u601"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,3270.2 882.2,3048 882.2,3209.8 1267.2,3432  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,3268.2 1646.2,3046 1646.2,3209.8 1265.3,3432  "
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "u701"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,3121 882.2,2898.8 882.2,3051.6 1267.2,3273.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,3119 1646.2,2896.8 1646.2,3051.6 1265.3,3273.8  "
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "u801"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,2959.2 637.5,2599.4 637.5,2761.2 1267.2,3121.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,2957.2 1646.2,2735 1646.2,2898.8 1265.3,3121.1  "
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "u901"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,2808.7 637.5,2448.9 637.5,2600.7 1267.2,2960.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,2806.7 1646.2,2584.5 1646.2,2738.3 1265.3,2960.6  "
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "u1001"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,2647.7 637.5,2287.8 637.5,2449.7 1267.2,2809.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,2645.7 1646.2,2423.5 1646.2,2587.3 1265.3,2809.5  "
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "u1101"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,2496.9 637.5,2137 637.5,2288.8 1267.2,2648.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,2494.9 1646.2,2272.7 1646.2,2426.5 1265.3,2648.7  "
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "u1201"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,2338.2 637.5,1978.3 637.5,2140.2 1267.2,2500.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,2336.2 1646.2,2114 1646.2,2277.8 1265.3,2500.1  "
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "u1401"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,2184.9 637.5,1825.1 637.5,1983.9 1267.2,2343.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,2181.9 1646.2,1959.7 1646.2,2121.6 1265.3,2343.8  "
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  id: "u1501"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,2037.1 637.5,1677.2 637.5,1824.1 1267.2,2183.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,2038.1 1646.2,1815.9 1646.2,1961.7 1265.3,2183.9  "
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "u1601"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1267.2,1861.6 637.5,1501.8 637.5,1676.6 1267.2,2036.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1265.3,1859.6 1646.2,1637.4 1646.2,1812.3 1265.3,2034.5  "
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "uPH3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "786.1,1422.8 189.9,1081.6 189.9,1253.4 786.1,1594.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "784.1,1427.8 1005.6,1298.1 1005.6,1464.9 784.1,1594.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1250.1,1437.8 1427.3,1334.3 1427.3,1503.1 1250.1,1606.6  "
}), /*#__PURE__*/React.createElement("g", {
  id: "1_501_2_"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1250.1,1437.8 1006.4,1300.3 1006.4,1469.2 1250.1,1606.6  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1091.7,1517.3 883.5,1635.6 1264.2,1857.6 1645.2,1635.7 1427.3,1503 1250.1,1603.8  "
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "uPH2"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "720.7,1234.5 189.9,932 189.9,1083.8 720.7,1386.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "718.5,1239.5 940,1109.8 940,1259.6 718.5,1386.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1250.1,1290.2 1427.3,1186.7 1427.3,1333.5 1250.1,1437  "
}), /*#__PURE__*/React.createElement("g", {
  id: "1_501_3_"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1250.1,1288.2 939.2,1111.1 939.2,1262 1250.1,1437  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "939.1,1261.6 720,1385.4 785.6,1426 1005.6,1299.7  "
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "uPH1"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "660.7,1053.8 536.9,980.2 536.9,793.4 254.1,630.1 254.1,807.2 189.9,767.1 189.9,935.3 660.7,1205.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "660,1054.7 881.5,925 881.5,1074.8 660,1201.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "536.5,795.1 758,665.4 758,850.2 536.5,978.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1250.1,1084.4 1427.3,980.9 1427.3,1185 1250.1,1288.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1008.2,627.2 1493.8,351.1 1493.8,884.5 1376.1,955.9 1427.3,983.2 1185.4,849.5 1008.2,946  "
}), /*#__PURE__*/React.createElement("g", {
  id: "1_501_4_"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1250.1,1082.6 1005.6,944.8 1005.6,625.5 476.2,306.5 477.5,499.6 757,665.4 758,852.2 880.8,925.8  880.8,1077.4 1250.1,1288.5  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "881.2,1073.4 660.7,1200.7 720.7,1234.8 940.7,1108.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "752.6,854 532.2,981.3 661.5,1051.7 881.5,925.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "254.1,730.2 189.9,769.2 254.1,807.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1186.1,848 1011.4,944.9 1250.1,1082.6 1427.3,983.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "479.5,499.6 253,626.9 532.9,792.4 752.9,666.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "958.9,38.3 476.3,308.3 1006.2,625.9 1493.8,351.1  "
}));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "u202"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "885.2,3679.5 628.9,3532.1 628.9,3693.9 885.2,3841.4  "
}));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  id: "u302"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "885.2,3518.8 488.2,3290.2 488.2,3452.1 885.2,3680.6  "
}));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  id: "u402"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "885.2,3368 488.2,3139.5 488.2,3291.3 885.2,3519.9  "
}));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  id: "u502"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "885.2,3218.3 488.2,2989.7 488.2,3141.6 885.2,3370.1  "
}));

var _ref24 = /*#__PURE__*/React.createElement("g", {
  id: "u602"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "885.2,3056.5 488.2,2828 488.2,2989.8 885.2,3218.4  "
}));

var _ref25 = /*#__PURE__*/React.createElement("g", {
  id: "u702"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "885.2,2907.4 488.2,2678.8 488.2,2831.6 885.2,3060.2  "
}));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  id: "u303"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "487.8,3289.9 64.5,3045.4 64.5,3207.3 487.8,3451.7  "
}));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  id: "u403"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "487.8,3139.2 64.5,2894.7 64.5,3046.5 487.8,3291  "
}));

var _ref28 = /*#__PURE__*/React.createElement("g", {
  id: "u503"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "487.8,2989.4 64.5,2744.9 64.5,2896.8 487.8,3141.2  "
}));

var _ref29 = /*#__PURE__*/React.createElement("g", {
  id: "u603"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "487.8,2827.7 64.5,2583.2 64.5,2745 487.8,2989.5  "
}));

var _ref30 = /*#__PURE__*/React.createElement("g", {
  id: "u204"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1257.4,3905.8 862,3675.2 862,3824.1 1257.4,4054.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1255.5,3905.8 1703,3645.9 1703,3794.9 1255.5,4054.7  "
}));

var _ref31 = /*#__PURE__*/React.createElement("g", {
  id: "u304"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1257.4,3761.2 862,3530.6 862,3679.6 1257.4,3910.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1255.5,3761.2 1703,3501.4 1703,3650.3 1255.5,3910.2  "
}));

var _ref32 = /*#__PURE__*/React.createElement("g", {
  id: "u404"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1257.4,3616.7 862,3386.1 862,3535 1257.4,3765.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1255.5,3616.7 1703,3356.8 1703,3505.8 1255.5,3765.6  "
}));

var _ref33 = /*#__PURE__*/React.createElement("g", {
  id: "u504"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1257.4,3472.1 862,3241.5 862,3390.5 1257.4,3621.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1255.5,3472.1 1703,3212.3 1703,3361.2 1255.5,3621.1  "
}));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  id: "u604"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1257.4,3327.6 862,3097 862,3245.9 1257.4,3476.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1255.5,3327.6 1703,3067.7 1703,3216.7 1255.5,3476.5  "
}));

var _ref35 = /*#__PURE__*/React.createElement("g", {
  id: "u703"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1257.4,3178 862,2947.4 862,3096.3 1257.4,3326.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1255.5,3178 1833.5,2844.3 1833.5,2993.2 1255.5,3326.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1831.6,2997.6 2084.4,2851.2 1703.8,2630.8 1616.7,2678.4 1831.6,2802.6  "
}));

var _ref36 = /*#__PURE__*/React.createElement("g", {
  id: "u802"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1255.5,3131.9 1832.5,2802.2 1617.8,2676 1039.8,3009.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1051.8,3009.7 1051.8,2896.7 862,2787.8 862,2899 862,2948.8 1257.4,3179.4 1257.4,3129.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1255.5,3131.9 1833.5,2800.2 1833.5,2845.7 1255.5,3179.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1051.8,2899.9 1051.8,2899.9 1140.9,2951.2 1051.8,3002.7  "
}));

var _ref37 = /*#__PURE__*/React.createElement("g", {
  id: "u902"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1142.7,2798.2 862,2634.8 862,2787.7 1142.7,2951.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1140.8,2798.2 1833,2400.9 1833,2553.8 1140.8,2951.2  "
}));

var _ref38 = /*#__PURE__*/React.createElement("g", {
  id: "u1002"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1142.7,2647.2 862,2483.8 862,2636.8 1142.7,2800.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1140.8,2647.2 1833,2249.9 1833,2402.9 1140.8,2800.2  "
}));

var _ref39 = /*#__PURE__*/React.createElement("g", {
  id: "u1102"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1142.7,2496.2 862,2332.8 862,2485.8 1142.7,2649.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1140.8,2496.2 1833,2098.9 1833,2251.9 1140.8,2649.2  "
}));

var _ref40 = /*#__PURE__*/React.createElement("g", {
  id: "u1202"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1142.7,2345.3 862,2181.8 862,2334.8 1142.7,2498.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1140.8,2345.3 1833,1947.9 1833,2100.9 1140.8,2498.2  "
}));

var _ref41 = /*#__PURE__*/React.createElement("g", {
  id: "u1402"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1142.7,2204.3 862,2040.9 862,2183.8 1142.7,2347.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1140.8,2204.3 1833,1807 1833,1949.9 1140.8,2347.2  "
}));

var _ref42 = /*#__PURE__*/React.createElement("g", {
  id: "u1502"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1142.7,2053.3 862,1889.9 862,2042.8 1142.7,2206.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1140.8,2053.3 1833,1656 1833,1808.9 1140.8,2206.2  "
}));

var _ref43 = /*#__PURE__*/React.createElement("g", {
  id: "u1602"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1142.7,1900.9 862,1737.4 862,1890.4 1142.7,2053.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1140.8,1900.9 1833,1503.5 1833,1656.5 1140.8,2053.8  "
}));

var _ref44 = /*#__PURE__*/React.createElement("g", {
  id: "BACK"
}, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M701.1,1094.1"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,2254.7 1142.7,2647.5 1142.7,2602.3 1831,2209.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,2104.1 1142.7,2496.9 1142.7,2451.8 1831,2059  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,1953.6 1142.7,2346.4 1142.7,2301.2 1831,1908.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,1809.7 1142.7,2202.5 1142.7,2157.3 1831,1764.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,1656.8 1142.7,2049.6 1142.7,2004.4 1831,1611.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,1508.5 1142.7,1901.3 1142.7,1856.1 1831,1463.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,1360.1 1142.7,1752.9 1142.7,1707.7 1831,1314.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,1201.8 1142.7,1594.6 1142.7,1549.4 1831,1156.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,1056.4 1142.7,1449.2 1142.7,1404 1831,1011.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,2404.2 1142.7,2797 1142.7,2751.8 1831,2359  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831,2557.2 1142.7,2950 1142.7,2906.9 1831,2514.1  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1831.6,2845.7 1257.4,3178.1 1257.4,3135 1831.6,2802.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1338.8,3276.9 1257.4,3323.9 1257.4,3280.9 1338.8,3233.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1338.8,3422.8 1257.4,3469.8 1257.4,3426.7 1338.8,3379.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1338.8,3568.6 1257.4,3615.6 1257.4,3572.5 1338.8,3525.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1338.8,3714.5 1257.4,3761.5 1257.4,3718.4 1338.8,3671.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1338.8,3860.3 1257.4,3907.3 1257.4,3864.2 1338.8,3817.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1338.8,4006.2 1257.4,4053.2 1257.4,4010.1 1338.8,3963.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1566.3,3253.2 1624.6,3219.6 1624.6,3118.4 1566.3,3152.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1566.3,3399.1 1624.6,3365.4 1624.6,3264.2 1566.3,3297.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1566.3,3544.9 1624.6,3511.3 1624.6,3410.1 1566.3,3443.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1566.3,3690.8 1624.6,3657.1 1624.6,3556 1566.3,3589.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1566.3,3836.7 1624.6,3803 1624.6,3701.8 1566.3,3735.5  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "1257.4,4199 1878.8,3840.2 2085.3,3721.1 2085.3,2852 1831.6,2997.6 1831.6,2802.6 1257.4,3135  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M1257.4,3281.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,1138.5 737.7,1172.1 737.7,1070.9 679.4,1037.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,1289.3 737.7,1323 737.7,1221.8 679.4,1188.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,1440.2 737.7,1473.8 737.7,1372.7 679.4,1339  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,1591 737.7,1624.7 737.7,1523.5 679.4,1489.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,1741.9 737.7,1775.6 737.7,1674.4 679.4,1640.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,1892.8 737.7,1926.4 737.7,1825.2 679.4,1791.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,2043.6 737.7,2077.3 737.7,1976.1 679.4,1942.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,2194.5 737.7,2228.1 737.7,2127 679.4,2093.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,2345.3 737.7,2379 737.7,2277.8 679.4,2244.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,2496.2 737.7,2529.9 737.7,2428.7 679.4,2395  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,2647.1 737.7,2680.7 737.7,2579.5 679.4,2545.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "679.4,2797.9 737.7,2831.6 737.7,2730.4 679.4,2696.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1257.4,3176.5 1051.8,3055.8 1051.8,3012.7 1257.4,3133.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1257.4,3322.3 1051.8,3201.6 1051.8,3158.5 1257.4,3279.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1257.4,3468.1 1051.8,3347.4 1051.8,3304.4 1257.4,3425.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1257.4,3614 1051.8,3493.3 1051.8,3450.2 1257.4,3570.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1257.4,3759.8 1051.8,3639.1 1051.8,3596 1257.4,3716.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1257.4,3905.7 1051.8,3785 1051.8,3741.9 1257.4,3862.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1257.4,4051.5 1051.8,3930.8 1051.8,3887.7 1257.4,4008.4  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1257.4,
  y1: 4008.4,
  x2: 1257.4,
  y2: 4197.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M1257.4,3286.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "1257.4,3133.2 1051.8,3012.5 1051.8,2898.8 1142.7,2951.2 1142.7,2906.1 1051.8,2853.7  1051.8,2744.7 1142.7,2797.2 1142.7,2752.1 1051.8,2699.6 1051.8,2595.7 1142.7,2648.1 1142.7,2603 1051.8,2550.6 1051.8,2444.6  1142.7,2497 1142.7,2451.9 1051.8,2399.5 1051.8,2294.7 1142.7,2347.2 1142.7,2302.1 1051.8,2249.6 1051.8,2149.9 1142.7,2202.3  1142.7,2157.2 1051.8,2104.8 1051.8,1997.8 1142.7,2050.3 1142.7,2005.2 1051.8,1952.7 1051.8,1849.5 1142.7,1901.9  1142.7,1856.8 1051.8,1804.4 1051.8,1701.1 1142.7,1753.6 1142.7,1708.4 1051.8,1656 1051.8,1542.6 1142.7,1595 1142.7,1549.9  1051.8,1497.5 1051.8,1397.6 1142.7,1450 1142.7,1404.9 1051.8,1352.5 1051.8,1240.4 1144.3,1293.8 1144.3,966.9 486.3,587.2  486.3,854.4 486.3,863.1 486.3,3750.3 1257.4,4197.4  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1781.8,599.7 1143.3,971.5 1143.3,1293.4 1781.8,921.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1613,419.1 1143.3,693.5 1143.3,971.5 1613,697  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 488.3,
  y1: 626.9,
  x2: 274.6,
  y2: 751.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 276.4,
  y1: 1156.7,
  x2: 24.9,
  y2: 1303.6
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "486.3,585 486.3,307.1 1143.3,693.5 1143.3,971.5  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831.6,
  y1: 2802.6,
  x2: 1616.7,
  y2: 2678.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 2084.4,
  y1: 2851.2,
  x2: 1703,
  y2: 2630.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1615.5,
  y1: 419.9,
  x2: 951.6,
  y2: 38.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1338.8,
  y1: 4006.2,
  x2: 1338.8,
  y2: 3132.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1051.8,
  y1: 3930.8,
  x2: 1051.8,
  y2: 3060.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 486.3,
  y1: 307.1,
  x2: 951.6,
  y2: 38.5
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "276.4,751.3 276.4,1449.3 24.9,1304.2 24.9,3194.2 486.3,3460.5 486.3,2645.6 486.3,1450.5  486.3,875.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "70.7,1512 129,1545.6 129,1444.4 70.7,1410.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "70.7,1662.8 129,1696.5 129,1595.3 70.7,1561.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "70.7,1813.7 129,1847.3 129,1746.2 70.7,1712.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "70.7,1964.5 129,1998.2 129,1897 70.7,1863.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "70.7,2115.4 129,2149.1 129,2047.9 70.7,2014.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "70.7,2266.2 129,2299.9 129,2198.7 70.7,2165.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "70.7,2417.1 129,2450.8 129,2349.6 70.7,2315.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "70.7,2569 129,2602.6 129,2501.4 70.7,2467.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "70.7,2719.8 129,2753.5 129,2652.3 70.7,2618.6  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1781.8,
  y1: 599.7,
  x2: 1611.4,
  y2: 499.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 2513.1,
  x2: 1736.6,
  y2: 2457.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 2358.3,
  x2: 1740.8,
  y2: 2305.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 2208.5,
  x2: 1740.8,
  y2: 2155.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 2057.7,
  x2: 1741,
  y2: 2004.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 1906,
  x2: 1747.9,
  y2: 1857.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 1763.9,
  x2: 1736.5,
  y2: 1708.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 1611.4,
  x2: 1745.4,
  y2: 1557.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 1460.6,
  x2: 1744.2,
  y2: 1409.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 1313.4,
  x2: 1734.6,
  y2: 1256.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 1156.1,
  x2: 1744.2,
  y2: 1105.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1831,
  y1: 1010.1,
  x2: 1730.8,
  y2: 951.3
}));

var _ref45 = /*#__PURE__*/React.createElement("g", {
  id: "FRONT"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "882.2,1639.1 882.2,3978.6 1264.2,4199.1 1264.2,1857.6  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1645.2,
  y1: 1635.7,
  x2: 1423.4,
  y2: 1502.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1427.4,
  y1: 985,
  x2: 1186.1,
  y2: 848
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "720.7,1386.3 720.7,1235.4 660.5,1200.6 660.5,1051.4 536.9,980.1 536.9,793.4 254.1,630.1  254.1,807.2 189.8,770.1 189.8,816.6 254.1,853.7 254.1,956.7 189.8,919.6 189.8,966.1 254.1,1003.2 254.1,1120.1 189.8,1083  189.8,1129.5 254.1,1166.7 254.1,1273.1 189.8,1236 189.8,1282.5 254.1,1319.6 254.1,1426.1 189.8,1388.9 189.8,1435.4  254.1,1472.6 254.1,1582.8 189.8,1545.7 189.8,1592.2 254.1,1629.3 254.1,1732.2 189.8,1695.1 189.8,1741.6 254.1,1778.7  254.1,1886.7 189.8,1849.6 189.8,1896.1 254.1,1933.2 254.1,2042.5 189.8,2005.3 189.8,2051.8 254.1,2089 254.1,2196.1 189.8,2159  189.8,2205.5 254.1,2242.6 254.1,2355 189.8,2317.9 189.8,2364.4 254.1,2401.5 254.1,2501.7 192.5,2466.2 192.5,2659.3  64.5,2584.8 64.5,3505.8 254.1,3615.9 301.1,3643.1 458.9,3734.2 550.3,3786.9 785.6,3922.8 785.6,1423.7  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 881.3,
  y1: 925.3,
  x2: 757.8,
  y2: 854
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1005.6,
  y1: 1299.7,
  x2: 939.2,
  y2: 1260.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 939.2,
  y1: 1109,
  x2: 881.4,
  y2: 1074.4
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "316.4,3651.9 316.4,3367.7 381.4,3405.3 381.4,3689.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,3353.3 316.4,3315.8 316.4,3208.6 381.4,3246.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,3202.2 316.4,3164.6 316.4,3057.4 381.4,3095  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,3051.1 316.4,3013.5 316.4,2906.3 381.4,2943.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,2894.8 316.4,2857.2 316.4,2750 381.4,2787.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,2738.5 316.4,2701 316.4,2593.7 381.4,2631.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,2582.2 316.4,2544.7 316.4,2437.5 381.4,2475  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,2425.9 316.4,2388.4 316.4,2281.2 381.4,2318.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,2270.7 316.4,2233.1 316.4,2125.9 381.4,2163.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,2115.4 316.4,2077.9 316.4,1970.7 381.4,2008.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,1960.2 316.4,1922.6 316.4,1815.4 381.4,1853  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,1804.9 316.4,1767.4 316.4,1660.2 381.4,1697.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,1656.7 316.4,1619.1 316.4,1511.9 381.4,1549.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "381.4,1501.5 316.4,1464 316.4,1356.7 381.4,1394.3  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "654.1,3846.9 654.1,3562.7 719.2,3600.3 719.2,3884.4  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "436.8,3721.4 436.8,3437.3 605.6,3534.8 605.6,3818.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,3548.3 654.1,3510.8 654.1,3403.6 719.2,3441.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,3408.1 438.2,3386.1 438.2,3278.9 476.3,3300.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,3443 498.7,3421.1 498.7,3313.8 536.8,3335.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,3478 559.2,3456 559.2,3348.8 597.3,3370.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,3257 438.2,3235 438.2,3127.8 476.3,3149.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,3291.9 498.7,3269.9 498.7,3162.7 536.8,3184.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,3326.9 559.2,3304.9 559.2,3197.6 597.3,3219.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,3105.9 438.2,3083.9 438.2,2976.6 476.3,2998.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,3140.8 498.7,3118.8 498.7,3011.6 536.8,3033.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,3175.7 559.2,3153.7 559.2,3046.5 597.3,3068.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,2949.6 438.2,2927.6 438.2,2820.4 476.3,2842.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,2984.5 498.7,2962.5 498.7,2855.3 536.8,2877.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,3019.4 559.2,2997.4 559.2,2890.2 597.3,2912.2  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "78.3,3514.4 78.3,3230.3 247.1,3327.8 247.1,3611.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "117.8,3201.1 79.7,3179.1 79.7,3071.9 117.8,3093.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "178.3,3236.1 140.2,3214.1 140.2,3106.9 178.3,3128.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "238.8,3271 200.7,3249 200.7,3141.8 238.8,3163.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "117.8,3050 79.7,3028 79.7,2920.8 117.8,2942.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "178.3,3084.9 140.2,3062.9 140.2,2955.7 178.3,2977.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "238.8,3119.9 200.7,3097.9 200.7,2990.7 238.8,3012.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "117.8,2898.9 79.7,2876.9 79.7,2769.7 117.8,2791.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "178.3,2933.8 140.2,2911.8 140.2,2804.6 178.3,2826.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "238.8,2968.8 200.7,2946.8 200.7,2839.5 238.8,2861.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "117.8,2742.6 79.7,2720.6 79.7,2613.4 117.8,2635.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "178.3,2777.5 140.2,2755.5 140.2,2648.3 178.3,2670.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "238.8,2812.5 200.7,2790.5 200.7,2683.3 238.8,2705.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,2793.3 438.2,2771.3 438.2,2664.1 476.3,2686.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,2828.2 498.7,2806.2 498.7,2699 536.8,2721  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,2863.2 559.2,2841.2 559.2,2734 597.3,2755.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,2637 438.2,2615 438.2,2507.8 476.3,2529.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,2671.9 498.7,2649.9 498.7,2542.7 536.8,2564.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,2706.9 559.2,2684.9 559.2,2577.7 597.3,2599.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,2481.8 438.2,2459.8 438.2,2352.5 476.3,2374.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,2516.7 498.7,2494.7 498.7,2387.5 536.8,2409.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,2551.6 559.2,2529.6 559.2,2422.4 597.3,2444.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,2329.6 438.2,2307.6 438.2,2200.4 476.3,2222.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,2364.5 498.7,2342.5 498.7,2235.3 536.8,2257.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,2399.5 559.2,2377.5 559.2,2270.3 597.3,2292.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,2170.2 438.2,2148.2 438.2,2041 476.3,2063  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,2205.2 498.7,2183.2 498.7,2075.9 536.8,2097.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,2240.1 559.2,2218.1 559.2,2110.9 597.3,2132.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,2016 438.2,1994 438.2,1886.8 476.3,1908.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,2050.9 498.7,2028.9 498.7,1921.7 536.8,1943.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,2085.9 559.2,2063.9 559.2,1956.7 597.3,1978.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,1861.8 438.2,1839.8 438.2,1732.6 476.3,1754.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,1896.7 498.7,1874.7 498.7,1767.5 536.8,1789.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,1931.7 559.2,1909.7 559.2,1802.4 597.3,1824.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,1707.6 438.2,1685.6 438.2,1578.3 476.3,1600.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,1742.5 498.7,1720.5 498.7,1613.3 536.8,1635.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,1777.4 559.2,1755.4 559.2,1648.2 597.3,1670.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "476.3,1555.3 438.2,1533.3 438.2,1426 476.3,1448  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "536.8,1590.2 498.7,1568.2 498.7,1461 536.8,1483  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "597.3,1625.1 559.2,1603.1 559.2,1495.9 597.3,1517.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,3397.2 654.1,3359.6 654.1,3252.4 719.2,3290  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,3246.1 654.1,3208.5 654.1,3101.3 719.2,3138.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,3089.8 654.1,3052.2 654.1,2945 719.2,2982.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,2933.5 654.1,2895.9 654.1,2788.7 719.2,2826.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,2777.2 654.1,2739.7 654.1,2632.4 719.2,2670  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,2620.9 654.1,2583.4 654.1,2476.2 719.2,2513.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,2465.7 654.1,2428.1 654.1,2320.9 719.2,2358.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,2310.4 654.1,2272.9 654.1,2165.7 719.2,2203.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,2155.2 654.1,2117.6 654.1,2010.4 719.2,2048  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,1999.9 654.1,1962.4 654.1,1855.2 719.2,1892.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,1851.7 654.1,1814.1 654.1,1706.9 719.2,1744.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,1696.5 654.1,1658.9 654.1,1551.7 719.2,1589.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "385.9,1238.2 308.8,1193.7 308.8,1306 385.9,1350.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "498.8,1303.4 421.6,1258.8 421.6,1371.1 498.8,1415.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "385.9,1080.6 308.8,1036 308.8,1148.3 385.9,1192.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "498.8,1145.7 421.6,1101.2 421.6,1213.5 498.8,1258  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "616.9,1213.9 536.9,1167.8 536.9,1280.1 616.9,1326.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "385.9,928.3 308.8,883.7 308.8,996 385.9,1040.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "498.8,993.4 421.6,948.9 421.6,1061.2 498.8,1105.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "637.5,1073.5 536.9,1015.5 536.9,1127.8 637.5,1185.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "385.9,761.6 308.8,717.1 308.8,829.4 385.9,874  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "498.8,826.8 421.6,782.2 421.6,894.6 498.8,939.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "616.9,1371.5 536.9,1325.4 536.9,1437.7 616.9,1483.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,1748.3 921.8,1703.7 921.8,1816.1 999,1860.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,1813.4 1034.6,1768.9 1034.6,1881.2 1111.8,1925.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,1878.6 1147.5,1834 1147.5,1946.4 1224.6,1990.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,1903.4 921.8,1858.9 921.8,1971.2 999,2015.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,1968.6 1034.6,1924 1034.6,2036.4 1111.8,2080.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,2033.7 1147.5,1989.2 1147.5,2101.5 1224.6,2146.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,2051.7 921.8,2007.2 921.8,2119.5 999,2164  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,2116.9 1034.6,2072.3 1034.6,2184.6 1111.8,2229.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,2182 1147.5,2137.4 1147.5,2249.8 1224.6,2294.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,2208 921.8,2163.4 921.8,2275.8 999,2320.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,2273.1 1034.6,2228.6 1034.6,2340.9 1111.8,2385.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,2338.3 1147.5,2293.7 1147.5,2406.1 1224.6,2450.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,2362.2 921.8,2317.7 921.8,2430 999,2474.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,2427.4 1034.6,2382.8 1034.6,2495.1 1111.8,2539.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,2492.5 1147.5,2448 1147.5,2560.3 1224.6,2604.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,2517.5 921.8,2472.9 921.8,2585.2 999,2629.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,2582.6 1034.6,2538.1 1034.6,2650.4 1111.8,2694.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,2647.8 1147.5,2603.2 1147.5,2715.5 1224.6,2760.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,2672.7 921.8,2628.2 921.8,2740.5 999,2785  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,2737.9 1034.6,2693.3 1034.6,2805.6 1111.8,2850.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,2803 1147.5,2758.5 1147.5,2870.8 1224.6,2915.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,2829 921.8,2784.4 921.8,2896.8 999,2941.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,2894.1 1034.6,2849.6 1034.6,2961.9 1111.8,3006.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,2959.3 1147.5,2914.7 1147.5,3027.1 1224.6,3071.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,2985.3 921.8,2940.7 921.8,3053.1 999,3097.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,3050.4 1034.6,3005.9 1034.6,3118.2 1111.8,3162.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,3115.6 1147.5,3071 1147.5,3183.4 1224.6,3227.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,3144.1 921.8,3099.6 921.8,3211.9 999,3256.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,3209.3 1034.6,3164.7 1034.6,3277.1 1111.8,3321.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,3274.4 1147.5,3229.9 1147.5,3342.2 1224.6,3386.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,3297.8 921.8,3253.3 921.8,3365.6 999,3410.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,3363 1034.6,3318.4 1034.6,3430.8 1111.8,3475.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,3428.1 1147.5,3383.6 1147.5,3495.9 1224.6,3540.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,3449 921.8,3404.4 921.8,3516.8 999,3561.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,3514.1 1034.6,3469.6 1034.6,3581.9 1111.8,3626.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,3579.3 1147.5,3534.7 1147.5,3647.1 1224.6,3691.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "999,3600.1 921.8,3555.5 921.8,3667.9 999,3712.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1111.8,3665.2 1034.6,3620.7 1034.6,3733 1111.8,3777.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1224.6,3730.4 1147.5,3685.8 1147.5,3798.2 1224.6,3842.7  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "999,4046 999,3761.8 921.8,3717.3 921.8,4001.4  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "1111.8,4111.1 1111.8,3827 1034.6,3782.4 1034.6,4066.6  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "1224.6,4176.3 1224.6,3892.1 1147.5,3847.6 1147.5,4131.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "719.2,1430.6 647.3,1389.1 647.3,1501.4 719.2,1542.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "697,1260.1 647.3,1231.4 647.3,1343.8 697,1372.5  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "1264.2,1857.6 1646.2,1637.1 1646.2,3978.6 1264.2,4199.1  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1414.3,
  y1: 4115.1,
  x2: 1414.3,
  y2: 1773.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1505.1,
  y1: 1719.7,
  x2: 1505.1,
  y2: 4061.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 883.5,
  y1: 1637.6,
  x2: 1091.7,
  y2: 1517.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 785.6,
  y1: 1426,
  x2: 1005.6,
  y2: 1299.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 785.7,
  y1: 3924.3,
  x2: 882.2,
  y2: 3868.8
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "660.7,1200.7 880.8,1074.4 880.8,925.8 660.7,1052.2  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "719.2,1388.3 939.2,1262 939.2,1109.7 719.2,1236  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "536.9,791.8 757,665.4 757,853.8 536.9,980.2  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "256.3,627.8 476.3,501.5 757,665.4  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1005.6,
  y1: 1563.5,
  x2: 1005.6,
  y2: 1300.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 2280.2,
  x2: 189.9,
  y2: 2317.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 2121.5,
  x2: 189.9,
  y2: 2158.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 1967.7,
  x2: 189.9,
  y2: 2004.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 1812,
  x2: 189.9,
  y2: 1848.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 1656.7,
  x2: 189.9,
  y2: 1693.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 1507.2,
  x2: 189.9,
  y2: 1544
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 1351.2,
  x2: 189.9,
  y2: 1388.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 1197.4,
  x2: 189.9,
  y2: 1234.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 1044.8,
  x2: 189.9,
  y2: 1081.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 883.7,
  x2: 189.9,
  y2: 920.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 254.1,
  y1: 730.2,
  x2: 189.9,
  y2: 767.1
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "1250.1,1604.6 1250.1,1084 1005.6,944.7 1005.6,624.9 476.3,306.5 476.3,501.5  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "1207.3,1580.4 1207.3,1114.5 1005.6,999 1005.6,1464.9  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1207.3,
  y1: 1264.7,
  x2: 1005.6,
  y2: 1149.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1207.3,
  y1: 1414.5,
  x2: 1005.6,
  y2: 1299
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1069.6,
  y1: 1037.2,
  x2: 1069.6,
  y2: 1501.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1138,
  y1: 1076.1,
  x2: 1138,
  y2: 1540.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1250.1,
  y1: 1604.5,
  x2: 1427.3,
  y2: 1503
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1250.1,
  y1: 1083.3,
  x2: 1427.3,
  y2: 983.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1427.3,
  y1: 1503,
  x2: 1427.3,
  y2: 983.2
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M1415.3,721.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M1005.6,944.8"
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1005.6,
  y1: 944.8,
  x2: 1186.1,
  y2: 848
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1005.6,
  y1: 625.5,
  x2: 1493.8,
  y2: 351.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 476.2,
  y1: 306.5,
  x2: 953,
  y2: 38.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1493.8,
  y1: 1546.6,
  x2: 1493.8,
  y2: 348.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1493.8,
  y1: 351.1,
  x2: 953,
  y2: 38.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 1005.6,
  y1: 1463.9,
  x2: 1250.1,
  y2: 1603.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 64.5,
  y1: 2583.8,
  x2: 192.5,
  y2: 2509.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 255.1,
  y1: 2428.6,
  x2: 190.9,
  y2: 2465.4
}));

var SvgBuilding = function SvgBuilding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Building",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2116.6 4214",
    style: {
      enableBackground: "new 0 0 2116.6 4214"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuilding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building.afe806b0.svg";
export { ForwardRef as ReactComponent };